import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/[sportSlug]/page.tsx");
